<template>
  <div class="dynamic-field-editor">
    <!-- Display mode -->
    <div
      v-if="!isEditing"
      class="hover-container position-relative"
    >
      <div
        v-b-tooltip.hover.top.v-light.html
        class="d-flex flex-column content-ad-account"
        :title="value ? value : '--'"
      >
        <p class="mb-0 wrap-content">
          {{ value ? value : '--' }}
        </p>
      </div>
      <feather-icon
        icon="EditIcon"
        size="14"
        class="edit-button position-absolute cursor-pointer"
        @click="$emit('toggle-edit')"
      />
    </div>

    <!-- Edit mode -->
    <div
      v-else
      class="d-flex align-items-center"
    >
      <b-input-group
        :class="errors.length > 0 ? 'is-invalid' : null"
        :style="getInputGroupStyle()"
      >
        <b-form-input
          v-model="localValue"
          :name="fieldName"
          :type="inputType"
          :placeholder="placeholder"
          style="height: 38px"
          :state="errors.length > 0 ? false : null"
          @keyup.enter="handleSave"
          @keyup.esc="$emit('cancel-edit')"
        />
      </b-input-group>

      <!-- Save/Cancel buttons -->
      <feather-icon
        icon="CheckIcon"
        size="14"
        class="mx-1 text-danger cursor-pointer"
        @click="handleSave"
      />
      <feather-icon
        icon="XIcon"
        size="14"
        class="cursor-pointer"
        @click="$emit('cancel-edit')"
      />

      <small
        v-if="errors.length > 0"
        class="text-danger ml-2"
      >{{ errors[0] }}</small>
    </div>
  </div>
</template>

<script>
import {
  BFormInput, BInputGroup, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  components: {
    BFormInput,
    BInputGroup,
  },

  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    fieldName: {
      type: String,
      default: '',
    },
    inputType: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      localValue: this.value,
    }
  },

  watch: {
    value(newVal) {
      this.localValue = newVal
    },
  },

  methods: {
    handleSave() {
      this.$emit('input', this.localValue)
      this.$emit('toggle-edit')
    },

    getInputGroupStyle() {
      const displayValue = this.value ? String(this.value) : '--'
      // Calculate width based on character count (approximate 8px per character for most fonts)
      const charWidth = 8
      const minWidth = 100 // minimum width for input
      const maxWidth = 500 // maximum width for input

      // Calculate input width based on value length
      const calculatedWidth = Math.max(minWidth, Math.min(maxWidth, displayValue.length * charWidth + 20))

      return {
        width: `${calculatedWidth}px`,
        minWidth: `${minWidth}px`,
        maxWidth: `${maxWidth}px`,
      }
    },
  },
}
</script>

<style scoped>
.dynamic-field-editor {
  max-width: 100%;
  width: max-content;

  .wrap-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.edit-button {
  opacity: 0;
  transition: opacity 0.3s ease;
  top: -3px;
  right: -18px;
  color: #e11c4e;
}

.hover-container:hover .edit-button {
  opacity: 1;
}
</style>
